import {Link} from 'react-router-dom';
import {observer} from 'mobx-react';
import Transition from 'react-transition-group/Transition'
import fecha from 'fecha';
import CONTENT from '../stores/Content';
import UI from '../stores/UI';
import HELP from '../stores/Help';
import IntroPadding from '../components/IntroPadding';

const FormatDate = ({datetime, format}) => {
  return (
    <span>{fecha.format(new Date(datetime), format)}</span>
  )
}

const ListThumb = ({x, y, src}) => {
  return (
    <div className="list-thumb" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '200px',
      height: '200px',
      transform: `translate(${x + 10}px, ${y + 10}px)`,
      zIndex: 100
    }}>
      <div className="fs pabs contain" style={{
        backgroundImage: `url(${src}?w=400)`
      }}></div>
    </div>
  )
}

class ListItem extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false,
      showThumb: false,
      x: 0,
      y: 0
    }

    this.timer = null;
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({
        show: true
      })
    }, this.props.delay)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  handleMouseMove = e => {
    this.setState({
      x: e.clientX,
      y: e.clientY,
      showThumb: true
    })
  }

  handleMouseLeave = () => {
    this.setState({
      showThumb: false
    })
  }

  render() {

    const fields = this.props;
    const duration = 800;
    const transitionStyles = {
      entering: { opacity: 0 },
      entered:  { opacity: 1 },
    };

    return (
      <Transition in={this.state.show} timeout={duration}>
        {(state) => (
          <Link to={{
            pathname: `/project/${this.props.slug}`,
            // state: { modal: true }
          }} className="item" style={{
            transition: `opacity ${duration}ms ease-in-out`,
            opacity: 0,
            ...transitionStyles[state]
          }} onMouseMove={this.handleMouseMove} onMouseLeave={this.handleMouseLeave}>
            <div>
              <span className="h3">{fields.client ? `${fields.client.fields.name} ` : ''}</span>
              <span className="p3">{`${fields.title}`}</span>
            </div>
            {this.state.showThumb && !UI.isTouch ? <ListThumb {...this.state} {...HELP.getMedia(fields.thumbnail)} /> : null}
          </Link>
        )}
      </Transition>
    )
  }
}

class ProjectIndex extends React.Component {

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    UI.toggleIntroPadding(false)
    CONTENT.fetchAllProjects()
  }

  render() {

    return (
      <div className="fs">
        <IntroPadding />
        <div className="fs innerx8 page-top">
          <div className="project-index txt-c outer" style={{
            paddingBottom: '10rem'
          }}>
            {CONTENT.projects ? CONTENT.projects.map(({fields}, i) => <ListItem {...fields} key={fields.slug} delay={i * 250} />) : null}
          </div>
        </div>
      </div>
    )
  }
}

export default observer(ProjectIndex)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/ProjectIndex.js